/**
 * 公共翻译 - 英文
 * Common translations - English
 */
import { CommonTranslations } from './zh';

export const commonEn: CommonTranslations = {
  // Common navigation
  overview: 'Overview',
  dashboard: 'Dashboard',
  admin: 'Admin',
  settings: 'Settings',

  // Common Actions
  create: 'Create',
  creating: 'Creating...',
  edit: 'Edit',
  delete: 'Delete',
  deleting: 'Deleting...',
  save: 'Save',
  saving: 'Saving...',
  saveChanges: 'Save Changes',
  cancel: 'Cancel',
  confirm: 'Confirm',
  submit: 'Submit',
  reset: 'Reset',
  search: 'Search',
  filter: 'Filter',
  selected: 'Selected',
  export: 'Export',
  import: 'Import',
  download: 'Download',
  upload: 'Upload',
  refresh: 'Refresh',
  back: 'Back',
  backToList: 'Back to List',
  next: 'Next',
  previous: 'Previous',
  first: 'First',
  previousPage: 'Previous',
  nextPage: 'Next',
  close: 'Close',
  view: 'View',
  viewAll: 'View All',
  details: 'Details',
  viewDetails: 'View Details',
  preview: 'Preview',
  actions: 'Actions',
  attributes: 'Attributes',
  quickActions: 'Quick Actions',
  clear: 'Clear',
  clearSearch: 'Clear Search',
  from: 'From',
  filtered: 'filtered',
  confirmRemove: 'Confirm Remove',
  pinned: 'Pinned',
  templateDownloaded: 'Template Downloaded',
  fileParseError: 'File Parse Error',
  manualRestore: 'Manual Restore',
  restoreSuccess: 'User Restored Successfully',
  restoreFailed: 'Failed to Restore User',
  batchUpdateFailed: 'Batch Update Failed',
  removeFailed: 'Failed to Remove',
  members: 'Members',
  addFailed: 'Failed to Add',
  primary: 'Primary',
  updating: 'Updating...',
  confirmUpdate: 'Confirm Update',
  downloadTemplate: 'Download Template',
  importing: 'Importing...',
  startImport: 'Start Import',
  restoring: 'Restoring...',
  confirmRestore: 'Confirm Restore',
  importFailed: 'Import Failed',
  searching: 'Searching...',
  noUsers: 'No Users Found',
  noMatchingUsers: 'No Matching Users',
  add: 'Add',
  setFailed: 'Failed to Set',
  checkingPermission: 'Checking permissions...',

  // Preview
  previewTitle: 'Feedback UI Preview',
  previewDescription: 'Preview visual differences for notifications and confirm dialogs',
  previewToastSection: 'Toast Notifications',
  previewToastHint: 'Click buttons to preview notifications in the top-right corner',
  previewDialogSection: 'Confirm Dialog',
  previewDialogHint: 'High-risk action confirmation example',
  previewToastSuccessTitle: 'Success',
  previewToastSuccessDesc: 'Changes have been saved',
  previewToastErrorTitle: 'Failed',
  previewToastErrorDesc: 'Please review and try again',
  previewToastWarningTitle: 'Warning',
  previewToastWarningDesc: 'This action will affect other members',
  previewToastInfoTitle: 'Info',
  previewToastInfoDesc: 'Processing in the background',
  previewToastLoadingTitle: 'Processing',
  previewToastLoadingDesc: 'Syncing data',
  previewToastNeutralTitle: 'Refreshed',
  previewToastNeutralDesc: 'List data updated',
  previewToastActionTitle: 'Attention needed',
  previewToastActionDesc: 'Updates require confirmation',
  previewToastActionLabel: 'Review',
  previewDialogOpen: 'Open delete confirmation',
  previewDialogTitle: 'Delete this department?',
  previewDialogDesc: 'This action cannot be undone and will remove related members.',
  previewDialogConfirm: 'Delete',
  previewSystemTitle: 'Global Feedback Preview',
  previewSystemDesc: 'Review dialogs, empty states, validation, and banners',
  previewConfirmSection: 'Confirm Dialogs',
  previewConfirmHint: 'Danger and primary confirmation styles',
  previewConfirmDangerOpen: 'Open danger confirm',
  previewConfirmPrimaryOpen: 'Open primary confirm',
  previewConfirmDangerTitle: 'Delete this member?',
  previewConfirmDangerDesc: 'This action cannot be undone and will remove related data.',
  previewConfirmDangerAction: 'Delete member',
  previewConfirmPrimaryTitle: 'Save changes?',
  previewConfirmPrimaryDesc: 'Member department and role settings will be updated.',
  previewConfirmPrimaryAction: 'Save changes',
  previewBannerSection: 'Top Banners',
  previewBannerHint: 'Used for maintenance or important notices',
  previewBannerMaintenanceTitle: 'Scheduled Maintenance',
  previewBannerMaintenanceDesc: 'Maintenance runs 23:00 - 02:00. Service may be impacted.',
  previewBannerNoticeTitle: 'Important Notice',
  previewBannerNoticeDesc: 'Bulk import is now available for organization structure.',
  envBannerUatTitle: 'Test Environment',
  envBannerUatDesc: 'This is a test environment. For verification only. Do not submit production data.',
  envBannerDevTitle: 'Development Environment',
  envBannerDevDesc: 'Development environment for feature verification only.',
  previewPageStateSection: 'Page States',
  previewPageStateHint: 'Error and empty state examples',
  previewPageErrorTitle: 'Failed to load',
  previewPageErrorDesc: 'Check your connection and refresh the page.',
  previewPageEmptyTitle: 'No data yet',
  previewPageEmptyDesc: 'No results match your current filters.',
  previewValidationSection: 'Field Validation',
  previewValidationHint: 'Error, warning, and success states',
  previewValidationFieldError: 'Member name',
  previewValidationFieldWarning: 'Member ID',
  previewValidationFieldSuccess: 'Member email',
  previewValidationPlaceholder: 'Enter a value',
  previewValidationErrorText: 'This field is required',
  previewValidationWarningText: 'Format may be invalid',
  previewValidationSuccessText: 'Looks good',
  
  // Status
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  enabled: 'Enabled',
  disabled: 'Disabled',
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  completed: 'Completed',
  inProgress: 'In Progress',
  cancelled: 'Cancelled',
  removing: 'Removing...',
  
  // Time
  time: 'Time',
  today: 'Today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  thisWeek: 'This Week',
  lastWeek: 'Last Week',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  thisYear: 'This Year',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  startDate: 'Start Date',
  endDate: 'End Date',
  
  // User Related
  user: 'User',
  users: 'Users',
  username: 'Username',
  password: 'Password',
  email: 'Email',
  phone: 'Phone',
  role: 'Role',
  roles: 'Roles',
  permissions: 'Permissions',
  profile: 'Profile',
  logout: 'Logout',
  
  // Data
  name: 'Name',
  description: 'Description',
  pleaseSelect: 'Please select...',
  otherSettings: 'Other Settings',
  type: 'Type',
  category: 'Category',
  tags: 'Tags',
  remark: 'Remark',
  required: 'Required',
  optional: 'Optional',
  fullTime: 'Full-time',
  partTime: 'Part-time',
  
  // Messages
  success: 'Success',
  error: 'Error',
  invalidInput: 'Invalid Input',
  warning: 'Warning',
  info: 'Info',
  loading: 'Loading...',
  loadFailed: 'Failed to Load',
  retry: 'Retry',
  noData: 'No Data',
  noResults: 'No Results',
  noMatchingResults: 'No Matching Results',
  tryOtherKeywords: 'Please try other keywords',
  noAlerts: 'No Alerts',
  noValidData: 'No valid data in Excel file',
  confirmDelete: 'Are you sure you want to delete?',
  deleteWarning: 'This action cannot be undone',
  operationSuccess: 'Operation Successful',
  operationFailed: 'Operation Failed',
  saveSuccess: 'Saved Successfully',
  saveFailed: 'Save Failed',
  deleteSuccess: 'Deleted Successfully',
  deleteFailed: 'Delete Failed',
  createSuccess: 'Created Successfully',
  createFailed: 'Create Failed',
  updateSuccess: 'Updated Successfully',
  updateFailed: 'Update Failed',
  
  // API Errors
  requestFailed: 'Request Failed',
  serverError: 'Server Error, Please Try Again Later',
  networkError: 'Network Connection Failed, Please Check Network Settings',
  unknownError: 'Unknown Error',
  noPermissionOperation: 'You Do Not Have Permission to Perform This Operation',
  permissionInsufficientDetail: 'Insufficient Permission: You Do Not Have the Required Permissions. Please Contact Administrator.',
  
  // Pagination
  page: 'Page',
  of: 'of',
  pageOf: ', ',
  pages: 'pages',
  pageSize: 'Items per page',
  total: 'Total',
  items: 'items',
  showingItems: 'Showing {start} to {end} of {total} items',
  totalRecords: 'Total {total} records',
  currentPage: 'Page {current} of {total}',
  prevPage: 'Previous',
  
  // Form Validation
  requiredField: 'This field is required',
  invalidEmail: 'Invalid email format',
  invalidPhone: 'Invalid phone format',
  invalidUrl: 'Invalid URL format',
  minLength: 'Minimum {min} characters',
  maxLength: 'Maximum {max} characters',
  minValue: 'Minimum value is {min}',
  maxValue: 'Maximum value is {max}',
  
  // Others
  all: 'All',
  none: 'None',
  noPermission: 'No Permission',
  permissionDeniedDetail: 'You do not have permission to access this page. Please contact the administrator.',
  select: 'Please Select',
  yes: 'Yes',
  no: 'No',
  unknown: 'Unknown',
  other: 'Other',
  more: 'More',
  less: 'Less',
  expand: 'Expand',
  collapse: 'Collapse',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  copySuccess: 'Copied Successfully',
  copyFailed: 'Copy Failed',
  submitting: 'Submitting...',
  copy: 'Copy',
  expandAll: 'Expand All',
  collapseAll: 'Collapse All',
  permissionDenied: 'Permission Denied',
  
  // Additional
  or: 'or',
  notAvailable: 'Not Available',
  submitter: 'Submitter',
  submitTime: 'Submit Time',
  manualInput: 'Manual Input',
  manage: 'Manage',
  
  // Form Validation and Navigation Confirmation
  validationFailed: 'Form validation failed',
  confirmLeave: 'Confirm Leave',
  unsavedChangesWarning: 'You have unsaved changes. Are you sure you want to leave?',
  stay: 'Stay',
  leave: 'Leave',
  selectDepartmentFirst: 'Please select a department first',
  remove: 'Remove',
  selectDepartment: 'Select Department',
  selectPosition: 'Select Position',
  selectManager: 'Select Manager',
  update: 'Update',
  
  // Additional common keys
  justNow: 'Just now',
  hoursAgo: 'hours ago',
  daysAgo: 'days ago',
  unassigned: 'Unassigned',
  uncategorized: 'Uncategorized',
  noOrganizationBanner: 'You are not a member of any organization. Most features will not work — please contact your admin to be added.',
  noOrganizationToastTitle: 'No organization context',
  noOrganizationToastDescription: 'You have no available organization. Requests requiring an organization context cannot be made. Please contact your admin.',
};
